<template>
  <!-- FIXME: 부고장: 교통 안내 -->
  <div id="traffic-modal" @click="close">
    <div class="modal" :class="{ 'is-empty': isParkingEmpty }" @click.stop>
      <div class="close" @click="close">
        <span>닫기</span>
      </div>
      <div class="content">
        <div v-if="type === 'parking'">
          <img v-if="exParkingFile" :src="exParkingFile.file_path" />
          <div v-else-if="pakingInfo" v-html="pakingInfo"></div>
          <div v-else>
            등록된 주차안내 정보가 없습니다. <br />
            교통안내를 참고하여 주시기 바랍니다.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TrafficModal",
  components: {},
  props: {
    address: {
      type: Object,
      default: Object,
    },
    trafficType: {
      type: String,
      default: String,
    },
  },
  data() {
    return {
      model: 0,
      type: "bus",
    };
  },
  created() {
    this.type = this.trafficType;

    if (this.address?.bus) {
      this.address.bus = this.address.bus.replaceAll(" ", "&nbsp;");
    }

    if (this.address?.subway) {
      this.address.subway = this.address.subway.replaceAll(" ", "&nbsp;");
    }

    if (this.address?.parking) {
      this.address.parking = this.address.parking.replaceAll(" ", "&nbsp;");
    }
  },
  computed: {
    ...mapGetters(["getObituaryFuneral"]),

    pakingInfo() {
      return this.getObituaryFuneral.PARKING_INFO;
    },

    exParkingFile() {
      const customFiles = this.getObituaryFuneral?.FuneralCustomFiles;
      if (!customFiles) {
        return null;
      }
      if (customFiles && customFiles?.length !== 0) {
        const parkingFile = customFiles.filter((v) => v.custom_type == 3)[0];
        return parkingFile;
      } else {
        return null;
      }
    },

    isParkingEmpty() {
      return !this.exParkingFile && !this.pakingInfo;
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
